import 'url-polyfill';
/**
 * @description: 处理url，去除hash值
 * @param {url}: 传入的url字符串，可以是"?"开头(如window.location.search)或不带"?"的查询字符串部分，也可以是一个完整的url。如果传入的是空值或不传入参数，将会解析当前页面的url
 * @return {handleUrl} url中的search字符串
 */
function handleUrlParams(url: string) {
    let handleUrl = url;
    if (url.startsWith('http')) {
        handleUrl = new URL(url).search;
    } else if (url.indexOf('#') > 0) {
        handleUrl = url.substring(0, url.indexOf('#'));
    }
    return handleUrl;
}

/**
 * @description: 解析url中的查询字符串
 * @param {url}: 传入的url字符串，可以是"?"开头(如window.location.search)或不带"?"的查询字符串部分，也可以是一个完整的url。如果传入的是空值或不传入参数，将会解析当前页面的url
 * @return {*} 解析后的key:value格式对象
 */
export function getUrlSearchParams(url = window.location.href) {
    const res: Record<string, string> = {};
    const handleUrl = handleUrlParams(url);
    if (!handleUrl) {
        return res;
    }
    const searchParams = new URLSearchParams(handleUrl);
    searchParams.forEach((value, key) => {
        res[key] = value;
    });
    return res;
}

/**
 * @description: url中的增加params
 * @param {url, params }: params为append到url的对象，格式如：{a: '1'}
 * @return {url}: 增加params的url字符串
 */
export function appendParamsToUrl(url: string | null, params: Record<string, string>): string {
    if (!url) {
        return '';
    }
    const copyUrl = new URL(url);
    const copyParams: URLSearchParams = new URLSearchParams(copyUrl.search);
    Object.keys(params).forEach((key: string) => {
        copyParams.append(key, params[key] ?? '');
    });
    copyUrl.search = copyParams.toString();
    return copyUrl.toString();
}
